import React from 'react';
import ContentTop from '@bit/bluekeel.component-library.content-top';
import styles from './Feed.css.js';
import Pcm from '@bit/bluekeel.component-library.pcm';
import Featured from '@bit/bluekeel.component-library.featured';
import Knowledge from '@bit/bluekeel.component-library.knowledge';
import Editorial from '@bit/bluekeel.component-library.editorial';
import Latest from '@bit/bluekeel.component-library.latest';
import Popular from '@bit/bluekeel.component-library.popular';
import Radium from 'radium';

const Feed = () => {
    const knowledgeFeeds = {
        credit_feed: Pcm['credit'], 
        reviews_feed: Pcm['reviews'], 
        tips_feed: Pcm['tips']
    };

    return (
        <div style={styles.feed}>
            <ContentTop key='content-top-pcm' text={styles.data.topText} />
            <Featured key='featured-row' feedData={Pcm.featured} styleVariants={styles.overrideFeatured}/>
            <Knowledge key='knowledge-row' data={knowledgeFeeds} styleVariants={styles.overrideKnowledge}/>
            <Editorial key='editorial-row' feedData={Pcm.featured} styleVariants={styles.overrideEditorial}/>
            <Latest key='latest-row' feedData={Pcm.latest} styleVariants={styles.overrideLatest}/>
            <Popular key='popular-row' feedData={Pcm.popular} styleVariants={styles.overridePopular}/>
        </div>
    );
}

export default Radium(Feed);